'use client';

import { createIcon } from './utils';

import type { TSVGIcon } from './interface';

export const QuoteIcon: TSVGIcon = createIcon({
  displayName: 'QuoteIcon',
  viewBox: '0 0 32 32',
  path: (
    <path d='m9.563 8.469-.813-1.25C3.125 11 0 15.594 0 19.375c0 3.656 2.688 5.375 4.969 5.375 2.875 0 4.906-2.438 4.906-5 0-2.156-1.375-4-3.219-4.688-.531-.188-1.031-.344-1.031-1.25 0-1.156.844-2.875 3.938-5.344zm12.406 0-.813-1.25c-5.563 3.781-8.75 8.375-8.75 12.156 0 3.656 2.75 5.375 5.031 5.375 2.906 0 4.969-2.438 4.969-5 0-2.156-1.406-4-3.313-4.688-.531-.188-1-.344-1-1.25 0-1.156.875-2.875 3.875-5.344z' />
  ),
});
